module.exports = __webpack_public_path__ + "static/img/dash-1.6cba95ed.png";